@if (description.recurrence || description.recurrenceInterval) {
  <div class="node-detail-popover-description_recurrence">
    <span class="node-detail-popover-description_recurrence-label">
      {{ 'Flowchart.NodeDetailDialog.Description.Recurrence' | transloco }}:</span
    >
    @if (description.recurrence !== -1) {
      <span> {{ description.recurrence }}x </span>
    } @else {
      {{ 'Flowchart.NodeDetailDialog.Description.Infinite' | transloco }}
    }
    @if (description.recurrenceInterval) {
      <span class="node-detail-popover-description_recurrence-label"
        >{{ 'Flowchart.NodeDetailDialog.Description.Interval' | transloco }}:</span
      >
      @switch (description.recurrenceInterval.type) {
        @case (TimeSpanType.Exact) {
          {{ 'Flowchart.NodeDetailDialog.Description.Every' | transloco }}
          {{ description.recurrenceInterval.from | transloco }}
        }
        @case (TimeSpanType.Max) {
          {{ 'Flowchart.NodeDetailDialog.Description.Max' | transloco }}
          {{ description.recurrenceInterval.from | transloco }}
        }
        @case (TimeSpanType.Min) {
          {{ 'Flowchart.NodeDetailDialog.Description.Min' | transloco }}
          {{ description.recurrenceInterval.from | transloco }}
        }
        @case (TimeSpanType.Range) {
          {{ description.recurrenceInterval.from | transloco }} - {{ description.recurrenceInterval.to | transloco }}
        }
      }
    }
  </div>
}

@if (description.description) {
  <common-rich-text-view class="node-detail-popover-description_description" [content]="description.description" />
}
